// @flow
import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'mastercard',
  icon: [
    29,
    19,
    null,
    null,
    null,
    <g id="mastercard" fillRule="nonzero" key="mastercard">
      <path
        d="M26.58,19 L2.42,19 C1.78347383,19.0053265 1.17090452,18.7575644 0.717061656,18.311223 C0.263218789,17.8648817 0.00528228465,17.2565265 0,16.62 L0,2.38 C0.00528228465,1.74347346 0.263218789,1.13511831 0.717061656,0.688776978 C1.17090452,0.242435646 1.78347383,-0.00532648787 2.42,4.4408921e-16 L26.58,4.4408921e-16 C27.2165262,-0.00532648787 27.8290955,0.242435646 28.2829383,0.688776978 C28.7367812,1.13511831 28.9947177,1.74347346 29,2.38 L29,16.63 C28.9835257,17.9515828 27.9016388,19.0111167 26.58,19 Z"
        id="shape"
        fill="#003663"
      />
      <circle id="shape" fill="#EB1C26" cx="10.5" cy="9.5" r="6.5" />
      <circle id="shape" fill="#F99F1B" cx="18.5" cy="9.5" r="6.5" />
      <path
        d="M14.5,4.38 C12.9213232,5.60970141 11.9981951,7.49890377 11.9981951,9.5 C11.9981951,11.5010962 12.9213232,13.3902986 14.5,14.62 C16.0786768,13.3902986 17.0018049,11.5010962 17.0018049,9.5 C17.0018049,7.49890377 16.0786768,5.60970141 14.5,4.38 L14.5,4.38 Z"
        id="shape"
        fill="#EF5D20"
      />
    </g>,
  ],
})
